import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FaInfoCircle } from "react-icons/fa";

import { calculatePercentage } from "@/utils/calculatePercentage";
import { getIndicatorClassificationColorClassName, IndicatorEsfEnum } from "@/utils/indicatorsEsf";
import { ResumeIndicatorC4Data } from "@/services/esus/indicator/esf/c4/getResumeIndicatorC4";

import { CardInformative } from "@/pages/esus/ReterritorializationAcsDashboard/CardInformative";
import { CardOverlayTrigger } from "@/components/CardOverlayTrigger";

type IndicatorEsfC4ResumeProps = {
	resume: ResumeIndicatorC4Data;
};

export function IndicatorEsfC4Resume({ resume }: Readonly<IndicatorEsfC4ResumeProps>) {
	const indicatorPercentage = calculatePercentage(
		resume.totalDiabeticCitizensInPeriodScore,
		resume.maxDiabeticCitizensInPeriodScore
	);

	return (
		<Row className="mx-0">
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Cidadãos identificados"
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={resume.totalDiabeticCitizens.toLocaleString()}
					metaData={
						<CardOverlayTrigger
							header="Cidadãos identificados"
							message="Quantidade de diabéticos identificados que estão sendo monitoradas no período informado"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Cidadãos avaliados"
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={resume.totalDiabeticCitizensInPeriod.toLocaleString()}
					metaData={
						<CardOverlayTrigger
							header="Cidadãos avaliados"
							message="Quantidade de diabéticos identificados que estão sendo monitoradas no período informado"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Pontuação"
					value={resume.totalDiabeticCitizensInPeriodScore.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Pontuação"
							message="Quantidade de pontos alcançados nas práticas realizadas no indicador(somatório de pontos de todos os cidadãos)"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="% Pontos alcançados"
					value={`${indicatorPercentage}%`}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue={`text-${getIndicatorClassificationColorClassName(
						IndicatorEsfEnum.C4,
						indicatorPercentage
					)}`}
					metaData={
						<CardOverlayTrigger
							header="% Pontos alcançados"
							message="Percentual de pontos alcançados em relação a pontuação máxima do indicador"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
		</Row>
	);
}
